// 统一请求路径前缀在libs/axios.js中修改
import {getRequest, postRequest,postRequestGangAn,getRequestGangAn, postCopyrightGsfwAward } from '@/libs/axios';


// 分页获取消息信息
export const _getByPage = (params) => {
    return postRequest('/copyrightregister/getByPage2', params)
};

// 获取登记详情信息
export const _getDetail = (params) => {
    return getRequest('/copyrightregister/getDetail', params)
};

// 前海版权公共服务平台获取登记详情信息
export const getRejectEnablCopyrightRegisterInfo = (params) => {
    return getRequestGangAn('/front/copyrightregister/getRejectEnablCopyrightRegisterInfo', params)
};



//版权登记 POST /bqjvip/copyrightRegisterDci/save
export const _save = (params) => {
    return postRequest('/copyrightregister/save', params)
};
//前海版权公共服务平台版权登记 POST /gangan/front/copyrightregister/save
export const _save2 = (params) => {
    return postRequestGangAn('/front/copyrightregister/save', params)
};

//前海版权公共服务平台版权登记保存获奖信息 POST /gangan/front/copyrightGsfwAward/save
/*export const _copyrightGsfwAwardSave = (params) => {
    return postCopyrightGsfwAward('/gangan/front/copyrightGsfwAward/save', params)
};*/

// 前海版权公共服务平台登记订单详情
export const getCopyrightRegisterInfo = (params)=>{
    return getRequestGangAn('/front/copyrightregister/getCopyrightRegisterInfo',params)
}

// 获取授时证书 /bqjvip/tsc/downloadTscCert/{subBizType}/{orderSeqNo}
export const tscCertBysn = (subBizType,orderSeqNo)=>{
    return getRequest(`/tsc/downloadTscCert/${subBizType}/${orderSeqNo}`)
}

//前海版权公共服务平台bc文件/bqjvip/blockChain/tianPing/downloadBc?subBizType=0201&orderSeqNo=YZ202106011641340585442
export const _getBcFile = (params) => {
    return postRequest('/blockChain/tianPing/downloadBc', params)
};






//POST /bqjvip/copyrightRegisterDci/reSubmit
export const _resubmit = (params) => {
    return postRequest('/copyrightregister/reSubmit', params)
}

//版权登记-折扣登记提交
export const _discountSave = (params) => {
    return postRequest('/copyrightregister/discount/save', params)
};
//版权登记-折扣重新提交
export const _discountResubmit = (params) => {
    return postRequest('/copyrightregister/discount/reSubmit', params)
}


// //获取作品类型列表
// export const _getWorkTypeList = (params) => {
//     return getRequest('/copyrightregister/getWorkTypeList', params)
// }

//获取作品类型列表 前海版权公共服务平台
export const _getWorkTypeList = (params) => {
    return getRequest('/copyrightregister/getGansuWorkTypeList', params)
}

//版权登记查询-短信验证码
export const _sendSmsCode = (params) => {
    return postRequest('/yccrm/sendSmsCode', params)
};

//版权登记查询-提交
export const _insertCustom = (params) => {
    return postRequest('/yccrm/insertCustom', params)
};



